/// <reference path="../../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Reports {
    import IReportControl = Meevo.Model.IReportControl;
    import IReportGeneralInfo = Meevo.Model.IReportGeneral;

    export class ReportControlsListComponent implements angular.IComponentController {
        reportControls: IReportControl[];
        form: angular.IFormController;
        hierarchyForm: ng.IFormController;
        selectedReport: IReportGeneralInfo;
        validationJson: Record<string, string>;
        reportModel: Record<string, string>;
        startDayOfWeek: number;
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportControlsList', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/report-controls-list/report-controls-list.component.html',
            controller: ReportControlsListComponent,
            controllerAs: '$ctrl',
            bindings: {
                reportControls: '<',
                form: '<',
                hierarchyForm: '<',
                selectedReport: '<',
                validationJson: '<',
                startDayOfWeek: '<',
                reportModel: '<',
            }
        });
}
